<template>
    <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent scrollable max-width="600px">
            <v-card>
                <v-card-title class="teal darken-2">
                    <span class="title" style="color: #fff;">{{ $t("passwordReset") }}</span>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text>
                    <v-form>
                        <v-flex v-if="step==1">
                            {{ $t("passwordResetReminder") }}
                        </v-flex>
                        <v-text-field
                            v-model="eMail"
                            v-if="step==1"
                            :label="$t('eMailAddress')"
                            single-line
                            hide-details
                            browser-autocomplete="username"
                        ></v-text-field>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 sm6 v-if="step==2">
                                    <v-text-field
                                        v-model="password1"
                                        :label="$t('password')"
                                        type="password"
                                        browser-autocomplete="new-password"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 v-if="step==2">
                                    <v-text-field
                                        v-model="password2"
                                        :label="$t('passwordConfirm')"
                                        type="password"
                                        browser-autocomplete="new-password"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="okClick">Ok</v-btn>
                    <v-btn color="error" @click="dialog = false">{{ $t("cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <message-box ref="MessageBox"/>
    </v-layout>
</template>

<script>
    import MessageBox from "./MessageBox";

    export default {
        name: "PasswordResetDialog",

        components: {
            MessageBox
        },

        data () {
            return {
                dialog:         false,
                code:           "",
                eMail:          "",
                password1:      "",
                password2:      "",
                recaptchaToken: "",
                step:           1
            }
        },

        async mounted () {
            // TODO recapctha, на данный момент не работает
            //await this.$recaptchaLoaded();
            //const token     = await this.$recaptcha("login");
            //const recaptcha = this.$recaptchaInstance;
            //recaptcha.hideBadge();
        },

        methods: {

            async doReset () {
                //this.recaptchaToken = await this.$recaptcha("login");

                if (this.password1 !== this.password2) {
                    this.showMessageBox(this.$t("attention"), this.$t("passwordsMismatch"));
                    return;
                }

                this.axios({
                    method: "post",
                    url: `${this.$config.apiURL}users/pwdreset/`,
                    data: {
                        step:     2,
                        code:     this.code,
                        password: this.password1
                    }
                }).then(response => {
                    let r_data = response.data;
                    if (r_data.status == "success") {
                        this.showMessageBox(this.$t("information"), this.$t("passwordChanged"));
                    } else if (r_data.status == "failure" && r_data.error == "captcha_api_call_failed") {
                        this.showMessageBox(this.$t("attention"), this.$t("captchaAPICallFailed"));
                    } else if (r_data.status == "failure" && r_data.error == "captcha_check_negative") {
                        this.showMessageBox(this.$t("attention"), this.$t("captchaCheckNegative"));
                    } else if (r_data.status == "failure" && r_data.data == "confirmation_code_not_found") {
                        this.showMessageBox(this.$t("error"), this.$t("confirmationCodeNotFound"));
                    } else if (r_data.status == "failure") { // && r_data.data == "password_change_error") {
                        this.showMessageBox(this.$t("error"), this.$t("passwordChangeError"));
                    }
                }).catch(error => {
                    if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("errorDuringRequest"));
                    }
                });
                this.dialog = false;
            },

            generateCode () {
                this.axios({
                    method: "post",
                    url: `${this.$config.apiURL}users/pwdreset/`,
                    data: {
                        step:  1,
                        locale: this.$i18n.locale,
                        email: this.eMail
                    } //,
                    //withCredentials: true
                }).then(response => {
                    let r_data = response.data;
                    if (r_data.data == "message_sent") {
                        this.showMessageBox(this.$t("information"), this.$t("passwordResetMessageSent"));
                    }
                }).catch(err => {
                    //if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("errorDuringRequest"));
                    //}
                    this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}syslog/`,
                        data: {
                            messageType: "error",
                            messageText: `PasswordReset.vue -> generateCode: ${JSON.stringify(err)}`
                        },
                        withCredentials: true
                    }).then(response => {
                        if (response.data.status == "failure") {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    }).catch(error => {
                        if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("subscriptionExpired"));
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("errors.serverConnectionError"));
                        }
                    });
                });
                this.dialog = false;
            },

            okClick () {
                if (this.step == 1) {
                    this.generateCode();
                } else {
                    this.doReset();
                }
            },

            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            }
        }
    }
</script>
